import { render, staticRenderFns } from "./GiroForm.vue?vue&type=template&id=58fad48c"
import script from "./GiroForm.vue?vue&type=script&lang=js"
export * from "./GiroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports